import { useCallback, useMemo } from 'react';
import { css } from '@emotion/react';
import {
  useLocationService,
  useLocationHistory,
  type LocationServiceLocationItem,
  LocationPickerTray as LocationServicePicker,
  usePinnedLocations,
} from '@frontend/wam-location-service';
import { theme } from '@frontend/theme';

export type LocationPickerTrayProps = {
  onClose: () => void;
  onLocationSelection: (locationId: string) => void;
};

const styles = {
  trayWrapper: css({
    margin: `-${theme.spacing(4)}`,
    height: '105%',
  }),
};
export const LocationPickerTray = ({ onClose, onLocationSelection }: LocationPickerTrayProps) => {
  const { currentLocation, setCurrentLocationId } = useLocationService();
  const { locations: recentLocations, addLocation } = useLocationHistory();
  const { locations: pinnedLocations } = usePinnedLocations();

  const onChangeLocation = useCallback(
    (location: LocationServiceLocationItem) => {
      setCurrentLocationId(location.locationId);
      addLocation(location);
      onLocationSelection(location.locationId);
    },
    [addLocation]
  );

  const itemSections = useMemo(() => {
    return [
      {
        heading: 'Pinned Locations',
        items: pinnedLocations,
      },
      {
        heading: 'Recently Visited',
        items: recentLocations.filter((r) => !pinnedLocations.some((p) => p.locationId === r.locationId)),
      },
    ];
  }, [recentLocations, pinnedLocations]);

  return (
    <div css={styles.trayWrapper}>
      <LocationServicePicker
        currentLocation={currentLocation}
        itemSections={itemSections}
        onClose={onClose}
        onChangeLocation={onChangeLocation}
      />
    </div>
  );
};
